<i18n lang="yaml" locale="en">
  create form: Create form
  form: Form
  click to edit: Click here to edit.
  data saved: Your data was saved successfully.
</i18n>

<i18n lang="yaml" locale="de">
  form: Formular
  create form: Formular erstellen
  click to edit: Klicken Sie hier zum Editieren.
  data saved: Ihre Daten wurden erfolgreich gespeichert.
</i18n>

<template>
  <div
    @click.capture="handleEdit"
  >
    <form v-if="schema.fields.length">
      <vue-form-generator
        :schema="parsedSchema"
        :model="model"
      />
    </form>
    <placeholder
      v-else-if="$editMode"
      :message="$t('click to edit')"
    />
  </div>
</template>

<script>
import BaseModule from '@/components/modules/BaseModule'
import Placeholder from '@/components/editor/Placeholder'
import VueFormGenerator from 'vue-form-generator/dist/vfg-core.js'
import axios from 'axios'
import { Success } from '@/plugins/snotify'
import translatable from '@/store/mixins/translatable'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'form',
  components: {
    Placeholder,
    vueFormGenerator: VueFormGenerator.component
  },
  extends: BaseModule,
  customStore: translatable,
  props: {
    // eslint-disable-next-line
    _headlineCreateForm: {
      input: 'heading',
      label: 'create form'
    },
    schema: {
      label: 'form',
      input: 'form',
      type: Object,
      default: () => {
        return {
          fields: []
        }
      }
    }
  },
  data () {
    return {
      model: {}
    }
  },
  methods: {
    handleEdit () {
      if (this.$editMode) {
        this.$router.replace({ query: { edit: this.$store.getters.path } })
      }
    },
    onSubmit () {
      const data = {}
      for (const field in this.model) {
        data[field] = {}
        data[field].value = this.model[field]
        data[field].label = this.flatSchema.fields.find(f => f.model === field).label
      }
      axios.post(this.$root.$route.path + '/data', {
        form: this.$store.getters.name,
        data: data
      }).then(() => {
        this.model = {}
        new Success(this.$t('data saved', this.$root.$store.getters.contentLocale), 2000).open()
      })
    }
  },
  computed: {
    parsedSchema () {
      const schema = Object.assign({}, this.schema)
      // add submit callback to submit button
      const submitButton = schema.fields.find(f => f.type === 'submit')
      if (submitButton) {
        submitButton.onSubmit = this.onSubmit
      }
      return schema
    },
    flatSchema () {
      const flat = { fields: [] }
      for (const field of this.schema.fields) {
        flat.fields.push(field)
      }
      return flat
    },
    tag () {
      return (this.$editMode && this.$store.getters.type.name === this.$options.name) ? 'router-link' : 'div'
    }
  }
}
</script>

<style lang="css" src="vue-form-generator/dist/vfg-core.css" />

<style lang="scss" scoped>
  .content {
    form {
      /deep/ fieldset {
        border: none;
        padding: 0;
        margin: 0;
        line-height: 2rem;

        .form-group {
          margin-bottom: 1rem;
        }

        .field-input {
          label {
            display: none;
          }

          .field-wrap {
            input {
              width: 100%;
              padding: 12px 20px;
              box-shadow: none;
              border: none;
              border-radius: 5px;
              background: #fff;
              color: #222;
              font-size: 1rem;
              font-weight: 500;
              line-height: 2rem;
              letter-spacing: 0.25pt;
            }
          }
        }

        .field-submit {
          .field-wrap {
            input {
              width: 100%;
              padding: 12px 20px;
              background-color: color(main) !important;
              text-align: center;
              text-transform: uppercase;
              font-size: 1.15rem;
              font-weight: 700;
              line-height: 2rem;
              letter-spacing: 0.25pt;
              border-radius: 0;
              border: unset;
              margin-top: 1rem;
              border-radius: 5px;

              &:active {
                box-shadow: unset;
                transform: scale(0.97);
              }
            }
          }
        }

        .field-twCheckbox {
          label {
            display: none;
          }

          .field-wrap {
            background-color: #fff;
            position: relative;
            border-radius: 5px;

            label {
              padding: 12px 20px;
              width: 100%;
              display: block;
              color: #222;
              cursor: pointer;
              position: relative;
              transition: all 250ms ease-in;
              overflow: hidden;
              font-weight: 500;
              letter-spacing: 0.25pt;
              border-radius: 5px;

              &:after {
                width: 32px;
                height: 32px;
                content: '';
                border: 2px solid #d1d7dc;
                background-color: #fff;
                background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
                background-repeat: no-repeat;
                background-position: 2px 3px;
                border-radius: 50%;
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                transition: all 250ms ease-in;
              }

              &.checked {
                color: #fff;
                background-color: color('main');
              }

              &.checked:after {
                background-color: color('main-darker');
                border-color: color('main-darker');
              }
            }

            input {
              width: 32px;
              height: 32px;
              order: 1;
              z-index: 2;
              position: absolute;
              right: 30px;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
              visibility: hidden;
            }
          }
        }

        .field-staticText {
          font-size: 1.15rem;
          text-transform: uppercase;
          letter-spacing: 0.25pt;
          font-weight: 400;
          margin: 1.5rem 0;

          label {
            display: none;
          }
        }
      }
    }
  }
</style>
